import { ref } from "vue";

const defaults = {
    icon: null,
    label: "Action",
    disabled: false,
    tooltip: false,
    canRun: (self, params) => {
        return true;
    },
    onBegin: (self, params) => {},
    onComplete: (self, params) => {},
    onHandle: (self, params) => {},
};

export default class Action {
    constructor(options) {
        this.options = { ...defaults, ...options };
        this.processing = ref(false);
    }

    async run(params) {
        if (this.options.canRun(this, params)) {
            this.options.onBegin(this, params);
            await this.options.onHandle(this, params);
            this.options.onComplete(this, params);
        }
    }

    getLabel(param) {
        if (typeof this.options.label === "function") {
            return this.options.label(this, param);
        }

        return this.options.label;
    }

    getTooltip(param) {
        if (typeof this.options.tooltip === "function") {
            return this.options.tooltip(this, param);
        }

        return this.options.tooltip;
    }

    setProcessing(value) {
        this.processing.value = !!value;
    }

    getProcessing() {
        return this.processing.value;
    }

    clone() {
        return new RowAction(this.options);
    }
}
